import { nodeType } from "../constants"
import { initializeFilterNodes } from "./filterOperator"
import { initializeOrNodes } from "./orOperator"
import { initializeNotNodes } from "./notOperator"
import { initializeAndNodes } from "./andOperator"
import { initializePlainTextNodes } from "./plainText"

export const splitString = (string) => {
  let values = string.split("").reduce(
    (reducedValues, value, index) => {
      let { lastValue, values, totalQuotesCount, reducedQuotesCount } = reducedValues

      let quotesCount = (lastValue.value.match(/"/g) || []).length
      let notSpacesCount = (lastValue.value.match(/[^\s]/g) || []).length
      let lastCharacter = lastValue.value.slice(-1)

      let newReducedQuotesCount = value === '"' ? reducedQuotesCount + 1 : reducedQuotesCount
      let newValue = lastValue.value + value
      let newStartIndex =
        lastValue.startIndex == null && value != " " ? index : lastValue.startIndex
      let initialStartIndex = value != " " ? index : null
      let isStrictMatch = value === '"' && totalQuotesCount - (reducedQuotesCount + 1) > 0

      if (
        lastValue.value === "" ||
        value === " " ||
        (quotesCount === 1 && totalQuotesCount - reducedQuotesCount > 0)
      ) {
        return {
          totalQuotesCount,
          reducedQuotesCount: newReducedQuotesCount,
          lastValue: {
            isStrictMatch: lastValue.isStrictMatch || isStrictMatch,
            startIndex: newStartIndex,
            value: newValue,
          },
          values,
        }
      }

      if (value === '"') {
        if (
          (lastCharacter !== " " && totalQuotesCount - (reducedQuotesCount + 1) === 0) ||
          notSpacesCount === 0
        ) {
          return {
            totalQuotesCount,
            reducedQuotesCount: newReducedQuotesCount,
            lastValue: {
              isStrictMatch: lastValue.isStrictMatch || isStrictMatch,
              startIndex: newStartIndex,
              value: newValue,
            },
            values,
          }
        } else {
          return {
            totalQuotesCount,
            reducedQuotesCount: newReducedQuotesCount,
            lastValue: {
              isStrictMatch,
              startIndex: initialStartIndex,
              value,
            },
            values: [...values, lastValue],
          }
        }
      }

      if (
        (lastCharacter !== " " || notSpacesCount === 0) &&
        (lastCharacter !== '"' ||
          (quotesCount === 1 && totalQuotesCount - reducedQuotesCount === 0))
      ) {
        return {
          totalQuotesCount,
          reducedQuotesCount: newReducedQuotesCount,
          lastValue: {
            isStrictMatch: lastValue.isStrictMatch || isStrictMatch,
            startIndex: newStartIndex,
            value: newValue,
          },
          values,
        }
      } else {
        return {
          totalQuotesCount,
          reducedQuotesCount: newReducedQuotesCount,
          lastValue: {
            isStrictMatch,
            startIndex: initialStartIndex,
            value,
          },
          values: [...values, lastValue],
        }
      }
    },
    {
      totalQuotesCount: (string.match(/"/g) || []).length,
      reducedQuotesCount: 0,
      lastValue: {
        startIndex: null,
        value: "",
      },
      values: [],
    },
  )

  return values.lastValue.value === "" ? values.values : [...values.values, values.lastValue]
}

export const getAst = (string, doAddPosition = false, supportedFilterKeys = []) => {
  if (string == null || string.trim() === "") {
    return null
  }

  let tempNodes = splitString(string)
    .map((value) => ({ ...value, value: value.value.trim() }))
    .reduce((reducedValues, value) => {
      if (value.isStrictMatch || value.value.length <= 1) {
        return [...reducedValues, value]
      }

      let key = null
      let indexOfColon = value.value.indexOf(":")
      if (indexOfColon !== -1) {
        key = value.value.slice(0, indexOfColon).toLowerCase()
      }

      if (supportedFilterKeys.indexOf(key) === -1) {
        return [...reducedValues, value]
      }

      if (indexOfColon !== -1 && indexOfColon !== value.value.length - 1) {
        return [
          ...reducedValues,
          {
            type: nodeType.filterOperator,
            keyStartIndex: value.startIndex,
            keyEndIndex: value.startIndex + key.length,
            key: key,
          },
          {
            startIndex: value.startIndex + indexOfColon + 1,
            value: value.value.slice(indexOfColon + 1),
          },
        ]
      }
      if (indexOfColon !== -1) {
        return [
          ...reducedValues,
          {
            type: nodeType.filterOperator,
            keyStartIndex: value.startIndex,
            keyEndIndex: value.startIndex + key.length,
            key: key,
          },
        ]
      }

      return [...reducedValues, value]
    }, [])
    .map((value) => {
      if (!value.isStrictMatch) {
        if (value.type === nodeType.filterOperator) {
          return value
        }

        if (value.value === "OR") {
          return {
            type: nodeType.orOperator,
          }
        }

        if (value.value === "NOT") {
          return {
            type: nodeType.notOperator,
          }
        }

        if (value.value === "AND") {
          return {
            type: nodeType.andOperator,
          }
        }
      }

      return {
        type: nodeType.plainText,
        startIndex: value.startIndex,
        endIndex: value.startIndex + value.value.length,
        value: value.value.replace(/"/g, ""),
        isStrictMatch: value.isStrictMatch,
      }
    })

  tempNodes = initializePlainTextNodes(tempNodes, doAddPosition)
  tempNodes = initializeFilterNodes(tempNodes, doAddPosition)
  tempNodes = initializeOrNodes(tempNodes)
  tempNodes = initializeNotNodes(tempNodes)
  tempNodes = initializeAndNodes(tempNodes)

  return tempNodes.length === 1 ? tempNodes[0] : null
}

export const getFilterNodeByPosition = (node, startIndex, endIndex) => {
  if (node == null || startIndex == null || endIndex == null || startIndex != endIndex) {
    return null
  }

  if (
    node.type === nodeType.filterOperator &&
    startIndex >= node.startIndex &&
    endIndex <= node.endIndex
  ) {
    return node
  }

  if (
    node.type === nodeType.orOperator ||
    node.type === nodeType.notOperator ||
    node.type === nodeType.andOperator
  ) {
    for (let i = 0; i < node.values.length; i++) {
      let nestedNode = getFilterNodeByPosition(node.values[i], startIndex, endIndex)
      if (nestedNode != null) {
        return nestedNode
      }
    }
  }

  return null
}
